// 003: the join screens' frame: the no-school product header "Akaiva Edu Power" (R-9; decision
// 2026-10-03) above one centred column (max 440 on the web, 16 px gutters on phones).
import type { ReactNode } from "react";
import { ScrollView, StyleSheet, View } from "react-native";

import { ProductHeader } from "@/shell/header/ProductHeader";
import { makeStyles } from "@/theme/makeStyles";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    screen: { flex: 1, backgroundColor: t.color.background },
    scroll: {
      flexGrow: 1,
      alignItems: "center",
      paddingHorizontal: t.space.lg,
      paddingVertical: t.space.x2l,
    },
    column: { width: "100%", maxWidth: 440, gap: t.space.lg },
  }),
);

export function JoinLayout({
  children,
  testID,
  header = true,
}: {
  children: ReactNode;
  testID?: string;
  /** False inside the parent area, which has its own header. */
  header?: boolean;
}) {
  const styles = useStyles();
  return (
    <View style={styles.screen} testID={testID}>
      {header ? <ProductHeader /> : null}
      <ScrollView
        contentContainerStyle={styles.scroll}
        keyboardShouldPersistTaps="handled"
        role="main"
      >
        <View style={styles.column}>{children}</View>
      </ScrollView>
    </View>
  );
}
